import { Dialog, DialogActions, DialogContent } from '@material-ui/core';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { getDocumentHelper } from '../../../../actions/utility-actions';
import { FlatButton } from '../../../../components/button/FlatButton';
import { DialogHeader } from '../../../../components/dialog/DialogHeader';
import { DialogTrigger } from '../../../../components/dialog/DialogTrigger';
import { DateInput } from '../../../../components/form-elements/DateInput';
import { FullviewExportDocument } from '../../../../models/production/fullview-export-document';

export const FullviewExport = () => {

    const [isOpen, setIsOpen] = React.useState(false);
    const [cutoffDate, setCutoffDate] = React.useState(new Date());
    const dispatch = useDispatch();

    /**
     * Handle the dialog open click
     */
    const onOpenClick = () => {
        setIsOpen(true);
    };

    /**
     * Handle the diaog close click
     */
    const onCloseClick = () => {
        setCutoffDate(new Date());
        setIsOpen(false);
    };

    /**
     * Handler for changing the start date.
     * @param newDate The new start date as chosen 
     */
    const onCutoffDateChange = (newDate: Date) => {
        setCutoffDate(newDate);
    };

    /**
     * Format the dates and initiate the AccountMate report command
     */
    const runReport = () => {
        if (cutoffDate) {
            const req = new FullviewExportDocument(cutoffDate);
            dispatch(getDocumentHelper(req));
            onCloseClick();
        }
    };

    return (
        <React.Fragment>
            <div className="report-card-wrap blue">
                <div className="row">
                    <div className="col">
                        <div className="row">
                            <div className="col">
                                <h3>Fullview Export</h3>
                                <p>Get a csv export for fullview orders for a specified cutoff date.</p>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col">
                                <DialogTrigger
                                    onClick={onOpenClick}
                                    text="Run Report" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Dialog
                open={isOpen}
                className="report-dialog"
                onClose={onCloseClick}
                maxWidth="md"
                aria-labelledby="form-dialog-title">

                <DialogHeader>
                    <h1>Full View Export</h1>
                </DialogHeader>

                <DialogContent>
                    <div className="row">
                        <div className="col">
                            <p>Provide a cutoff date to search</p>
                        </div>
                    </div>
                    <div className="row justify-content-around">
                        <div className="col-auto">
                            <DateInput
                                id="cutoffDate"
                                label="Cutoff Date"
                                value={cutoffDate}
                                onChange={onCutoffDateChange}
                                inline={true}
                            />
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <FlatButton
                        id="windloadReportNoBtn"
                        text="Cancel"
                        classes="negative"
                        onBtnClick={onCloseClick} />
                    <FlatButton
                        id="windloadReportYesBtn"
                        text="Go"
                        classes="positive"
                        onBtnClick={runReport} />
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );

};
